import { Form } from 'antd';
import styled from '@emotion/styled';

export let StyledForm = styled(Form)`
  display: grid;
  grid-row-gap: 20px;
`;
